<blaze-cell-date
  #cellDateComponent
  [column]="column()"
  [rowNum]="rowNum()"
  [value]="dateValue()"
  [isDisabled]="isDisabled()"
  (valueChanged)="dateUpdated($event)"
  (pickerOpened)="datePickerOpened()"
  (pickerClosed)="datePickerClosed()"
/>

<blaze-cell-time
  #cellTimeComponent
  [column]="column()"
  [rowNum]="rowNum()"
  [value]="timeValue()"
  [isDisabled]="isDisabled()"
  (valueChanged)="timeUpdated($event)"
  (pickerOpened)="timePickerOpened()"
/>
